export default "__VITE_ASSET___KIyVr7h__"